export const HINT_LEVELS = [
  { level: 1, unlockSeconds: 5 * 60, label: "Hint 1", description: "Problem classification." },
  { level: 2, unlockSeconds: 8 * 60, label: "Hint 2", description: "Strategy selection." },
  { level: 3, unlockSeconds: 12 * 60, label: "Hint 3", description: "Key structural insight." },
  { level: 4, unlockSeconds: 17 * 60, label: "Hint 4", description: "Near-complete roadmap." },
  { level: 5, unlockSeconds: 22 * 60, label: "Hint 5", description: "Full explanation." },
];

const defaultResources = {
  1: [
    {
      id: "concept-check",
      title: "Pick the right technique",
      url: "https://www.khanacademy.org/math",
      description: "Short reminder of common calculus problem types.",
    },
  ],
  2: [
    {
      id: "setup-outline",
      title: "Outline your givens",
      url: "https://proofwiki.org/wiki/Category:Calculus",
      description: "Walk through setting up the variables before diving in.",
    },
  ],
  3: [
    {
      id: "worked-first-step",
      title: "See the opening move",
      url: "https://www.youtube.com/watch?v=Urc1ED2R_PE",
      description: "Example of a clean first manipulation to mirror.",
    },
  ],
  4: [
    {
      id: "partial-solution",
      title: "Partial solution scaffold",
      url: "https://tutorial.math.lamar.edu/",
      description: "Two to three steps into the solution so you can finish.",
    },
  ],
  5: [
    {
      id: "full-solution",
      title: "Full walk-through",
      url: "https://math.stackexchange.com/",
      description: "A comparable solved problem to cross-check your work.",
    },
  ],
};

const ratioTestResources = {
  1: [
    {
      id: "ratio-setup",
      title: "When to use the ratio test",
      url: "https://tutorial.math.lamar.edu/Classes/CalcII/SeriesTests.aspx",
      description: "Identify signals that the ratio test applies.",
    },
  ],
  2: [
    {
      id: "ratio-outline",
      title: "Ratio test outline",
      url: "https://www.youtube.com/watch?v=OSe6sF7ZyDA",
      description: "High-level plan for constructing the ratio.",
    },
  ],
  3: [
    {
      id: "ratio-first-step",
      title: "First step",
      url: "https://brilliant.org/wiki/ratio-test/",
      description: "Compute a_{n+1}/a_n cleanly.",
    },
  ],
  4: [
    {
      id: "ratio-partial",
      title: "Work the algebra",
      url: "https://tutorial.math.lamar.edu/Problems/CalcII/SeriesConvPtII.aspx",
      description: "Partial simplification to show the pattern.",
    },
  ],
  5: [
    {
      id: "ratio-full",
      title: "Solved example",
      url: "https://www.khanacademy.org/math/ap-calculus-bc/bc-series-new/bc-10-9/v/ratio-test-examples",
      description: "Full ratio test example with conclusion.",
    },
  ],
};

export const HINT_RESOURCES = {
  "Integration – by parts": {
    1: [
      {
        id: "ibp-choice",
        title: "Choosing u and dv",
        url: "https://tutorial.math.lamar.edu/Classes/CalcII/IntegrationByParts.aspx",
        description: "Criteria for picking u and dv to simplify the integral.",
      },
    ],
    2: [
      {
        id: "ibp-strategy",
        title: "IBP strategy outline",
        url: "https://www.youtube.com/watch?v=8Yw4HqrpP94",
        description: "High-level plan for IBP with common patterns.",
      },
    ],
    3: [
      {
        id: "ibp-step",
        title: "First step example",
        url: "https://openstax.org/books/calculus-volume-2/pages/7-1-integration-by-parts",
        description: "See the first substitution and simplification.",
      },
    ],
    4: [
      {
        id: "ibp-partial",
        title: "Partial IBP solution",
        url: "https://www.youtube.com/watch?v=1LEiRqu8MSc",
        description: "Work through the early integration pieces together.",
      },
    ],
    5: [
      {
        id: "ibp-full",
        title: "Complete IBP walkthrough",
        url: "https://tutorial.math.lamar.edu/Problems/CalcII/IntByParts.aspx",
        description: "Reference solution to compare against your own.",
      },
    ],
  },
  "Ratio test": ratioTestResources,
  "Series – ratio test": ratioTestResources,
  default: defaultResources,
};

export const getResourcesForType = (problemType) => {
  if (HINT_RESOURCES[problemType]) {
    return HINT_RESOURCES[problemType];
  }
  return HINT_RESOURCES.default || defaultResources;
};

export default HINT_RESOURCES;
